import { Icon } from '@timeedit/ui-components';
import { Cascader, Typography } from '@timeedit/ui-components/antd';
import './CascadeMenu.scss';

export type CascadeOption = {
  value: string;
  label: string;
  disabled?: boolean;
  children?: CascadeOption[];
};

export type CascadeMenuProps = {
  options: CascadeOption[];
  onClick?: (value: string) => void;
};

export const CascadeMenu = ({ options, onClick }: CascadeMenuProps) => {
  return (
    <Cascader
      options={options}
      onChange={(val) => onClick && onClick(val[1].toString())}
    >
      <Typography.Link className="cascade-add-btn" data-testid="add-btn">
        Add
        <Icon id="DownOutlined" alt="Down" className="add-btn" />
      </Typography.Link>
    </Cascader>
  );
};
